export enum ValidationError {
    REQUIRED = 'required',
    INVALID_DATE = 'invalid-date',
    DATE_NOT_GREATER = 'date-not-greater',
    MIN = 'min',
    MAX = 'max',
    MIN_LENGTH = 'minlength',
    MAX_LENGTH = 'maxlength',
    PATTERN = 'pattern',
    EMAIL = 'email',
    IMPORT_ERROR = 'import-error',
    IMPORT_NAMES_ERROR = 'import-names-error',
    END_DATE_BEFORE_START_DATE = 'end-date-before-start-date',
    INVALID_OPTION = 'invalidOption'
}
